export default __webpack_public_path__ + "static/media/appStoreapple.56c6de40.png";